import axios from 'axios';
import { conf } from '../confg';
import { MAX_ONLINE_TRANSACTION_TOMAN } from '../themeSetting';

let cachedPromise = null;

/**
 * Public payment gateway settings from GET /api/site-info
 * (enabled providers + transfer_receipt — no secrets).
 */
export function fetchPaymentGatewaySettings({ force = false } = {}) {
  if (!force && cachedPromise) {
    return cachedPromise;
  }

  cachedPromise = axios({ url: conf.server_url + 'site-info', method: 'GET' })
    .then((res) => {
      const data = res?.data?.data || {};
      const paymentGateway = data.payment_gateway || {};
      const transferReceipt = {
        enabled: Boolean(
          (paymentGateway.transfer_receipt || data.transfer_receipt || {}).enabled
        ),
        admin_review_minutes: Number(
          (paymentGateway.transfer_receipt || data.transfer_receipt || {})
            .admin_review_minutes
        ) || 10,
        upload_deadline_hours: Number(
          (paymentGateway.transfer_receipt || data.transfer_receipt || {})
            .upload_deadline_hours
        ) || 24,
      };
      const providers = Array.isArray(paymentGateway.providers)
        ? paymentGateway.providers
        : [];

      return {
        enabled: paymentGateway.enabled !== false,
        default_provider: paymentGateway.default_provider || 'sep',
        providers,
        transfer_receipt: transferReceipt,
        deposit: paymentGateway.deposit || data.deposit || { enabled: true },
        max_amount_toman: resolveMaxAmountToman(paymentGateway),
      };
    })
    .catch(() => {
      cachedPromise = null;
      return {
        enabled: true,
        default_provider: 'sep',
        providers: [
          { key: 'sep', name: 'سامان (SEP)', enabled: true },
          { key: 'zarinpal', name: 'زرین‌پال', enabled: true },
        ],
        transfer_receipt: { enabled: false },
        deposit: { enabled: true },
        max_amount_toman: MAX_ONLINE_TRANSACTION_TOMAN,
      };
    });

  return cachedPromise;
}

export function getEnabledOnlineProviders(settings) {
  if (!settings?.enabled) return [];
  return (settings.providers || []).filter((p) => p && p.enabled);
}

export function resolveMaxAmountToman(paymentGateway) {
  const toman = Number(paymentGateway?.max_amount_toman);
  if (Number.isFinite(toman) && toman > 0) return Math.floor(toman);
  const rial = Number(paymentGateway?.max_amount_rial);
  if (Number.isFinite(rial) && rial > 0) return Math.floor(rial / 10);
  return MAX_ONLINE_TRANSACTION_TOMAN;
}

export function formatGatewayLimit(toman) {
  const amount = Math.max(0, Math.floor(Number(toman) || 0));
  if (amount > 0 && amount % 1000000 === 0) return `${amount / 1000000} میلیون تومان`;
  return `${amount.toLocaleString('en-US')} تومان`;
}
